import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useAuth } from '../../../contexts/AuthContext';
import { useLanguage } from '../../../contexts/LanguageContext';

const IncidentsTab = ({ siteId, siteData, incidents, onRefresh, isReadOnly = false }) => {
  const { userProfile } = useAuth();
  const { t } = useLanguage();

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical': return 'var(--color-destructive)';
      case 'high': return 'var(--color-warning)';
      case 'medium': return 'var(--color-accent)';
      case 'low': return 'var(--color-success)';
      default: return 'var(--color-muted-foreground)';
    }
  };

  const getIncidentTypeLabel = (type) => {
    return type?.replace('_', ' ')?.split(' ')?.map(w => w?.charAt(0)?.toUpperCase() + w?.slice(1))?.join(' ');
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">{t('incidentReports')}</h3>
        {(userProfile?.role === 'admin' || userProfile?.role === 'worker') && !isReadOnly && (
          <Button
            size="sm"
            iconName="Plus"
            onClick={() => window.location.href = `/incident-reporting?siteId=${siteId}`}
          >
            {t('reportIncident')}
          </Button>
        )}
      </div>
      {incidents?.length > 0 ? (
        <div className="space-y-3">
          {incidents?.map((incident) => (
            <div key={incident?.id} className="bg-muted/50 rounded-lg border border-border p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-start gap-3 flex-1">
                  <div className="flex items-center justify-center w-10 h-10 bg-background rounded-lg flex-shrink-0">
                    <Icon
                      name="AlertTriangle"
                      size={20}
                      color={getSeverityColor(incident?.severity_level)}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="font-medium text-foreground">{getIncidentTypeLabel(incident?.incident_type)}</h4>
                      <span
                        className="px-2 py-0.5 text-xs font-medium rounded-full"
                        style={{
                          backgroundColor: `${getSeverityColor(incident?.severity_level)}20`,
                          color: getSeverityColor(incident?.severity_level)
                        }}
                      >
                        {incident?.severity_level}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground mb-2">{incident?.description}</p>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span>{new Date(incident?.incident_date)?.toLocaleDateString()}</span>
                      <span>{t('reportedBy')} {incident?.user_profiles?.full_name || t('unknown')}</span>
                    </div>
                  </div>
                </div>
              </div>
              {incident?.immediate_action_taken && (
                <div className="bg-background rounded p-3 text-sm">
                  <p className="text-muted-foreground mb-1">{t('immediateAction')}:</p>
                  <p className="text-foreground">{incident?.immediate_action_taken}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-muted/50 rounded-lg p-12 border border-border text-center">
          <Icon name="AlertTriangle" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h4 className="text-lg font-semibold text-foreground mb-2">{t('noIncidentsRecorded')}</h4>
          <p className="text-sm text-muted-foreground mb-4">{t('noIncidentsDesc')}</p>
          {(userProfile?.role === 'admin' || userProfile?.role === 'worker') && !isReadOnly && (
            <Button
              size="sm"
              iconName="Plus"
              onClick={() => window.location.href = `/incident-reporting?siteId=${siteId}`}
            >
              {t('reportIncident')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default IncidentsTab;